import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add language to all requests
api.interceptors.request.use((config) => {
  const language = localStorage.getItem('language') || 'en';
  config.params = {
    ...config.params,
    lang: language,
  };
  return config;
});

export default api;

export const getMediaUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  const MEDIA_URL = process.env.REACT_APP_MEDIA_URL || 'http://localhost:8000/media';
  return `${MEDIA_URL}/${path}`;
};
